// utils/permissions.ts
import { getSession } from "@/api/http";
import catalogue from "@/config/permissionCatalogue.json";

// Permissions are named "Can <action> <Module>" (e.g. "Can approve CAPA"). The
// signed-in user's list comes from GET /auth/me into the reactive session, so
// menus and v-if="hasPermission(…)" buttons update as soon as it loads.

export const getUserPermissions = (): string[] => {
  try {
    return getSession().permissions;
  } catch (e) {
    return [];
  }
};

export const hasPermission = (permissionName: string): boolean => {
  const permissions = getUserPermissions();
  return permissions.includes(permissionName);
};

// The API's PermissionCatalogue (`php artisan rbac:export-catalogue`), used
// by the specs to reject a mistyped permission name.
export const ALL_PERMISSIONS: string[] = Object.values(catalogue as Record<string, Record<string, string[]>>).flatMap(
  (modules) => Object.entries(modules).flatMap(([module, actions]) => actions.map((action) => `Can ${action} ${module}`)),
);

export const isKnownPermission = (name: string) => ALL_PERMISSIONS.includes(name);
